import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import mapValues from 'lodash/mapValues';

import { types as actions, setTagsAction } from '../../reducers/actions';
import { TagSerializer } from '../../models';
import { SUPER_TAG } from '../../constants/data';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.UPDATE_TAGS_TIME),
    map(() => {
      let data = store.getState().tags.data;
      return setTagsAction(
        mapValues(data, area => ({
          ...area,
          tags: area.tags.map(tag => {
            let t = TagSerializer.normalizeTime(tag.time)
            if(tag.deviceType === SUPER_TAG){ //HACK
              t.deviceType = SUPER_TAG;
            }
            return ({
              ...tag,
              time: t
            })
          })
        }))
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/updateTagsTime.js